// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__121V9","notes":"Notes_notes__FUvcM"};